import { render, staticRenderFns } from "./taohnpsf.vue?vue&type=template&id=7470c9c4&scoped=true&"
import script from "./taohnpsf.vue?vue&type=script&lang=js&"
export * from "./taohnpsf.vue?vue&type=script&lang=js&"
import style0 from "./taohnpsf.vue?vue&type=style&index=0&id=7470c9c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7470c9c4",
  null
  
)

export default component.exports